/*
 * Copyright (C) 2009-2025 SonarSource Sàrl
 * All rights reserved
 * mailto:info AT sonarsource DOT com
 */

import { IconSparkleInShield, Text, TextSize, Tooltip } from '@sonarsource/echoes-react';
import { FormattedMessage } from 'react-intl';
import { BareButton } from '~design-system';
import { BaseProfile } from '~sq-server-commons/types/quality-profiles';
import { ProfileInheritanceDetails } from '~sq-server-commons/types/types';
import { isQualityProfileRecommendedForAI } from '../../utils';

interface Props {
  className?: string;
  profile: BaseProfile | ProfileInheritanceDetails;
}

export default function ProfileRecommendedForAiIcon({ profile, className }: Readonly<Props>) {
  if (!isQualityProfileRecommendedForAI(profile)) {
    return null;
  }

  return (
    <Tooltip content={<FormattedMessage id="quality_profiles.aica.tooltip.icon" />}>
      <Text size={TextSize.Default}>
        <BareButton className={className}>
          <IconSparkleInShield color="echoes-color-icon-accent" />
        </BareButton>
      </Text>
    </Tooltip>
  );
}
